module.exports = __webpack_public_path__ + "static/media/aliados.74c73c28.jpg";